import { Routes, Route, Navigate } from "react-router-dom";
import { VendorDashboardScreen } from "screens/App/CRM/Dashboard/VendorDashboardScreen";
import ShipmentListScreen from "screens/App/CRM/ShipmentRequest/ShipmentListScreen";
import ShipmentCompletionListScreen from "screens/App/CRM/ShipmentCompletion/DeliveryListScreen";
import ShipmentDetailScreen from "screens/App/CRM/ShipmentRequest/ShipmentDetailScreen";
import ShipmentCompletionDetailScreen from "screens/App/CRM/ShipmentCompletion/DeliveryDetailScreen";
import CodTransferListScreen from "screens/App/CRM/Payment/CodTransfer/CodTransferListScreen";
import PrepaymentListScreen from "screens/App/CRM/Payment/Prepayment/PrepaymentListScreen";
import AdjustmentListScreen from "screens/App/CRM/Payment/Adjustment/AdjustmentListScreen";
import PaymentAccountListScreen from "screens/App/CRM/Payment/PaymentAccount/PaymentAccountListScreen";
import CodTransferDetailScreen from "screens/App/CRM/Payment/CodTransfer/CodTransferDetailScreen";
import PrepaymentDetailScreen from "screens/App/CRM/Payment/Prepayment/PrepaymentDetailScreen";
import AdjustmentDetailScreen from "screens/App/CRM/Payment/Adjustment/AdjustmentDetailScreen";
import PaymentAccountDetailScreen from "screens/App/CRM/Payment/PaymentAccount/PaymentAccountDetailScreen";
import TicketListScreen from "screens/App/CRM/Ticket/TicketListScreen";
import TicketDetailScreen from "screens/App/CRM/Ticket/TicketDetailScreen";
import CocCollectionDetailScreen from "screens/App/CRM/Payment/CocCollection/CocCollectionDetailScreen";
import ShipmentReviewScreen from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ShipmentReviewScreen";
import { VendorSideProfilesDetail } from "screens/App/CRM/Contact/VendorProfile/VendorSideProfilesDetail";
import ShipmentVendorCreateScreen from "screens/App/CRM/ShipmentRequest/ShipmentVendorCreateScreen";
import VendorStaffRouter from "./VendorStaffRouter";
import CocCollectionListScreen from "screens/App/CRM/Payment/CocCollection/CocCollectionListScreenForVendor";
import DeliveryCollectionListScreen from "screens/App/CRM/Payment/DeliveryCollection/DeliveryCollectionListScreenForVendor";
import AnnouncementListScreen from "screens/App/CRM/Announcement/AnnouncementListScreen";
import AnnouncementCreateScreen from "screens/App/CRM/Announcement/AnnouncementCreateScreen";
import AnnouncementEditScreen from "screens/App/CRM/Announcement/AnnouncementEditScreen";
import AnnouncementDetailScreen from "screens/App/CRM/Announcement/AnnouncementDetailScreen";
import ShipmentVendorEditScreen from "screens/App/CRM/ShipmentRequest/ShipmentVendorEditScreen";
import BranchListScreen from "screens/App/CRM/Branch/BranchListScreen";
import BranchDetailScreen from "screens/App/CRM/Branch/BranchDetailScreen";
import VendorTicketCreateScreen from "screens/App/CRM/Ticket/VendorTicketCreateScreen";
import VendorTicketEditScreen from "screens/App/CRM/Ticket/VendorTicketEditScreen";
import IntegrationRouter from "./IntegrationRouter";
import NotificationRouter from "./NotificationRouter";
import ShipmentActionRouter from "./ShipmentActionRouter";
import VendorPendingCodListScreen from "screens/App/CRM/Payment/CodTransfer/VendorPendingCodListScreen";
import VendorPaymentDetails from "screens/App/CRM/Payment/CodTransfer/VendorPaymentDetails";

export const VendorSidebarRouter = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<VendorDashboardScreen />} />
      <Route path="profile" element={<VendorSideProfilesDetail />} />
      <Route path="notification/*" element={<NotificationRouter />} />
      <Route path="vendorBulkImport" element={<ShipmentReviewScreen />} />
      <Route path="cod-transfer/list" element={<CodTransferListScreen />} />
      <Route path="pending-cod" element={<VendorPendingCodListScreen />} />
      <Route path="action-list/*" element={<ShipmentActionRouter />} />
      <Route
        path="counter-collection/list"
        element={<CocCollectionListScreen />}
      />
      <Route
        path="counter-collection/:id/detail"
        element={<CocCollectionDetailScreen />}
      />
      <Route
        path="delivery-collection/list"
        element={<DeliveryCollectionListScreen />}
      />
      <Route path="staffs/*" element={<VendorStaffRouter />} />

      <Route
        path="cod-transfer/:id/detail"
        element={<CodTransferDetailScreen />}
      />
      <Route path="adjustment/list" element={<AdjustmentListScreen />} />
      <Route
        path="adjustment/:id/detail"
        element={<AdjustmentDetailScreen />}
      />
      <Route
        path="payment-account/list"
        element={<PaymentAccountListScreen />}
      />
      <Route path="prepayment/list" element={<PrepaymentListScreen />} />
      <Route
        path="prepayment/:id/detail"
        element={<PrepaymentDetailScreen />}
      />
      <Route path="payment-details" element={<VendorPaymentDetails />} />
      <Route
        path="payment-account/:id/detail"
        element={<PaymentAccountDetailScreen />}
      />
      <Route path="shipment/create" element={<ShipmentVendorCreateScreen />} />
      <Route path="shipment/list" element={<ShipmentListScreen />} />
      <Route path="shipment/:id/edit" element={<ShipmentVendorEditScreen />} />
      <Route path="shipment/:id/detail" element={<ShipmentDetailScreen />} />
      <Route
        path="shipment-completion/list"
        element={<ShipmentCompletionListScreen />}
      />
      <Route
        path="shipment-completion/:id/detail"
        element={<ShipmentCompletionDetailScreen />}
      />
      <Route path="ticket/list" element={<TicketListScreen />} />
      <Route path="ticket/create" element={<VendorTicketCreateScreen />} />
      <Route path="ticket/:id/edit" element={<VendorTicketEditScreen />} />
      <Route path="ticket/:id/detail" element={<TicketDetailScreen />} />

      <Route path="announcement/list" element={<AnnouncementListScreen />} />
      <Route
        path="announcement/create"
        element={<AnnouncementCreateScreen />}
      />
      <Route
        path="announcement/:id/edit"
        element={<AnnouncementEditScreen />}
      />
      <Route
        path="announcement/:id/detail"
        element={<AnnouncementDetailScreen />}
      />
      <Route path="integration/*" element={<IntegrationRouter />} />
      <Route path="branch/list" element={<BranchListScreen />} />
      <Route path="branch/:id/detail" element={<BranchDetailScreen />} />
    </Routes>
  );
};
